import React from "react";
import OverviewCard from "./OverviewCard";

const OverviewSection = ({ details }) => {
  return (
    <section className="overview-section">
      <h2>Overview - Today</h2>
      <div className="container">
        <OverviewCard details={details} version="view" />
        <OverviewCard details={details} version="likes" />
      </div>
    </section>
  );
};

export default OverviewSection;
